<template>
    <div>
        <div id="fileFolderModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ `${editing ? 'Rename' : 'New'} Folder` }}</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)" @submit.prevent>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="name"
                                       :class="{'text-red': form.errors.has('name')}">Name</label>
                                <input v-model="form.name" id="name" name="name"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('name')}">
                                <div class="text-red text-xs" v-if="form.errors.has('name')">{{ form.errors.get('name') }}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="save"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="fileFolderModal2" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">New Sub Folder</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="subFolderForm.errors.clear($event.target.name)" @submit.prevent>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="name"
                                       :class="{'text-red': subFolderForm.errors.has('name')}">Parent Folder</label>
                                <input v-model="subFolderForm.parent_folder" id="parent_folder" name="parent_folder" readonly
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': subFolderForm.errors.has('parent_folder')}">
                                <div class="text-red text-xs" v-if="subFolderForm.errors.has('parent_folder')">{{ subFolderForm.errors.get('parent_folder') }}</div>
                                <label class="text-sm text-grey-darkest -mb-0" for="name"
                                       :class="{'text-red': subFolderForm.errors.has('name')}">Name</label>
                                <input v-model="subFolderForm.folder_name" id="folder_name" name="folder_name"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': subFolderForm.errors.has('folder_name')}">
                                <div class="text-red text-xs" v-if="subFolderForm.errors.has('folder_name')">{{ subFolderForm.errors.get('folder_name') }}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="saveSubFolder"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-center">
            <div class="bg-white shadow-md rounded m-2 p-3 w-full">
                <div class="flex mb-2">
                    <div class="flex-1 text-left">
                        <h5>Project Folder Structure</h5>
                    </div>
                    <div class="flex-1 text-right">
                        <button data-toggle="modal" data-target="#fileFolderModal"
                                class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                            add
                        </button>
                    </div>
                </div>
                <fileFoldersSub v-model="data" :canDeleteFolders="canDeleteFolders"></fileFoldersSub>
            </div>
        </div>
    </div>
</template>


<script>
    import Form from "../../utils/form";
    import draggable from "vuedraggable";
    import subFolder from "./subFolder";
    import fileFoldersSub from "./file-folders-sub.vue";
    import Swal from "sweetalert2";

    export default {
        name: 'file-folders',
        components: {
            draggable,
            subFolder,
            fileFoldersSub
        },
        props:['canDeleteFolders'],
        data() {
            return {
                data: null,
                data_loading: false,
                form: new Form({
                    id: null,
                    name: '',
                    order: null,
                }),
                subFolderForm: new Form({
                    id: null,
                    folder_name: '',
                    parent_folder_id: '',
                    parent_folder: null,
                    order: null,
                }),
                editing: false,
            }
        },

        created(){
            this.fetchData();
        },
        mounted() {
            let self = this;
            $("#fileFolderModal").on('hidden.bs.modal', function () {
                self.form.reset();
                self.editing = false;
            });
            Bus.$on('addSubFolderEmit', (data) => {
                this.addSubFolder(data.parent_folder_id,data.parent_folder);
            });
            Bus.$on('renameSubFolderEmit', (data) => {
                this.form.id=data.id;
                this.form.name=data.name;
                this.form.order=data.order;
                this.editing=true;
                $("#fileFolderModal").modal('show');
            });

            Bus.$on('deleteSubFolderEmit', (data) => {
                this.deleteFolder(data)
            });
            Bus.$on('UpdateStateFolder', (data) => {
                this.onUpdate();
            });
            Bus.$on('UpdateStateEmitterFolder', (data) => {
                this.data = data;
            });
        },

        methods: {
            save() {
                const self = this;
                if (!this.editing){
                    this.form.post(route('api.settings.file-folder.store')).then((data) => {
                        $("#fileFolderModal").modal("hide");
                        self.alert(data);
                        self.fetchData();
                    });
                } else {
                    this.form.put(route('api.settings.file-folder.store')).then((data) => {
                        $("#fileFolderModal").modal("hide");
                        self.alert(data);
                        self.fetchData();
                    });
                }
            },

            deleteFolder(folder) {
                let self = this;
                this.alert(
                    {
                        status: 'warning',
                        html: `You won't be able to revert this!`,
                    },
                    'Are you sure?',
                    true,
                    'Yes, delete it!',
                ).then(result => {
                    if(result.value){
                        this.alert(
                            {
                                status: 'warning',
                                html: `Records can't be retrieved once deleted`,
                            },
                            folder.totalFolders+' folder(s) with '+ folder.totalResources +' file(s) will be deleted',
                            true,
                            "Yes, delete it!"
                        ).then(result => {
                            if(result.value) {
                                axios.delete(route('api.settings.file-folder.delete', folder.id)).then(data => {
                                    if(data.data.status === 'error') {
                                        Swal.fire({
                                            title: 'Warning',
                                            type: 'warning',
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            html: `<p>${data.data.message}</p><br>
                                                <button type="button" id="deleteAllBtn" class="btn btn-primary" style="background-color:#01B1AF;">Delete all files & folders</button>
                                                <button type="button" id="deleteFoldersBtn" class="btn btn-primary" style="background-color:#01B1AF;">Delete only folders</button>
                                                <button type="button" id="cancelBtn" class="btn btn-secondary">Cancel</button>`,
                                            onBeforeOpen: () => {
                                                const deleteAllBtn = document.querySelector('#deleteAllBtn');
                                                const deleteFoldersBtn = document.querySelector('#deleteFoldersBtn');
                                                const cancelBtn = document.querySelector('#cancelBtn');

                                                deleteAllBtn.addEventListener('click', () => {
                                                    axios.delete(route('api.settings.file-folder.delete-all', folder.id)).then((data) => {
                                                        self.alert(data.data, 'Deleted');
                                                        self.fetchData();
                                                    });
                                                    Swal.close();
                                                });
                                                deleteFoldersBtn.addEventListener('click', () => {
                                                    axios.delete(route('api.settings.file-folder.delete-only-folders', folder.id)).then((data) => {
                                                        self.alert(data.data, 'Deleted');
                                                        self.fetchData();
                                                    });
                                                    Swal.close();
                                                });
                                                cancelBtn.addEventListener('click', () => {
                                                    Swal.close();
                                                });
                                            }
                                        });
                                    }
                                    else {
                                        this.alert(data.data, 'Deleted');
                                    }

                                    this.fetchData();
                                });
                            }
                        })
                    }

                });
            },

            alert(data, title = null, cancelButton = false, confirmButtonText = 'OK!') {
                const alertTitle = title ?? (this.editing ? 'Renamed' : 'Created')
                return Swal.fire({
                    title: alertTitle,
                    text: data.message,
                    html: data.html,
                    type: data.status,
                    showCancelButton: cancelButton,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: confirmButtonText
                });
            },

            fetchData() {
                this.data_loading = true;
                let self = this;
                axios.get(route('api.settings.file-folder.index')).then(({data}) => {
                    self.data = data.data;
                    self.data_loading = false;
                });
            },

            onUpdate(e) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
                this.data.forEach((folder, index) => {
                    folder.order = index;
                });
                axios.put(route('api.settings.file-folder.order'), {'folders':this.data}).then((data) => {
                    Toast.fire({
                        type: "success",
                        title: "File Folder successfully ordered!"
                    });
                });
            },
            addSubFolder(folderId, folderName) {

                this.subFolderForm.parent_folder = folderName ;
                this.subFolderForm.parent_folder_id = folderId;
                $("#fileFolderModal2").modal('show');
            },
            saveSubFolder() {
                let self = this;
                self.subFolderForm.post(route('api.settings.file-sub-folder.store')).then((data) => {
                    $("#fileFolderModal2").modal('hide');
                    self.subFolderForm.reset();
                    Swal.fire({
                        title: 'Sub Folder Created',
                        text: data.message,
                        type: "success",
                        showCancelButton: false,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'OK!',
                    });
                    self.fetchData();
                });
            },
        }
    };
</script>
